'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('SnackbarBody', function (theme) {
  return _defineProperty({
    root: {
      fontFamily: theme.typography.body1.fontFamily,
      paddingTop: theme.typography.rhythmByUnit(1),
      paddingBottom: theme.typography.rhythmByUnit(1),
      padding: '0 ' + theme.typography.rhythmByUnit(3),
      borderRadius: 0,
      minHeight: theme.typography.rhythmByUnit(6),
      display: 'flex',
      maxWidth: 'inherit',
      minWidth: 'inherit',
      width: '100vw',
      flexGrow: 1,
      backgroundColor: theme.typography.primary.color
    },
    content: {
      fontSize: theme.typography.body1.fontSize,
      color: theme.palette.background.paper,
      opacity: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar
      })
    },
    action: {
      color: theme.palette.background.paper,
      float: 'right',
      backgroundColor: 'transparent',
      lineHeight: 'normal',
      '&:hover, &:focus': {
        backgroundColor: 'transparent'
      }
    },
    openContent: {
      opacity: 1,
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar,
        delay: 100
      })
    },
    error: {
      backgroundColor: theme.typography.error.color
    },
    centered: {
      justifyContent: 'center'
    }
  }, theme.breakpoints.up('md'), {
    root: {
      borderRadius: 5,
      maxWidth: 568,
      minWidth: 100,
      width: 'auto',
      flexGrow: 0
    }
  });
});

var SnackbarBody = (_temp = _class = function (_Component) {
  _inherits(SnackbarBody, _Component);

  function SnackbarBody() {
    _classCallCheck(this, SnackbarBody);

    return _possibleConstructorReturn(this, (SnackbarBody.__proto__ || Object.getPrototypeOf(SnackbarBody)).apply(this, arguments));
  }

  _createClass(SnackbarBody, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames2;

        var _props = this.props,
            action = _props.action,
            contentClass = _props.contentClass,
            message = _props.message,
            open = _props.open,
            onActionClick = _props.onActionClick,
            classNameProp = _props.className,
            error = _props.error,
            other = _objectWithoutProperties(_props, ['action', 'contentClass', 'message', 'open', 'onActionClick', 'className', 'error']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.error, error), classNameProp);
        var contentClassName = (0, _classnames2['default'])(classes.content, (_classNames2 = {}, _defineProperty(_classNames2, classes.openContent, open), _defineProperty(_classNames2, classes.centered, !action), _classNames2), contentClass);

        var actionButton = action && _react2['default'].createElement(
          _Button2['default'],
          {
            accent: true,
            compact: true,
            className: classes.action,
            onClick: onActionClick,
            raised: true
          },
          action
        );

        return _react2['default'].createElement(
          'div',
          _extends({}, other, { className: className }),
          _react2['default'].createElement(
            'div',
            { className: contentClassName },
            _react2['default'].createElement(
              'span',
              null,
              message
            ),
            actionButton
          )
        );
      }

      return render;
    }()
  }]);

  return SnackbarBody;
}(_react.Component), _class.propTypes = {
  /**
   * The label for the action on the snackbar.
   */
  action: _PropTypes2['default'].node,
  /**
   * The css class name of the content element.
   */
  contentClass: _PropTypes2['default'].string,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _PropTypes2['default'].node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _PropTypes2['default'].func,
  /**
   * @ignore
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _PropTypes2['default'].bool.isRequired,
  /**
   * The css class name of the body element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Indicates the snackbar body should use the error color scheme
   */
  error: _PropTypes2['default'].bool
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
}, _temp);


SnackbarBody.displayName = 'SnackbarBody';

exports['default'] = SnackbarBody;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Snackbar/SnackbarBody.js
// module id = 1861
// module chunks = 32